import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { languages } from 'src/app/demo/constants/languages';
import { Vehicle } from 'src/app/demo/models/common-data-types';
import { FormatCapitalizedConstantsService } from 'src/app/demo/service/format-capitalized-constants.service';
import { LanguageService } from 'src/app/demo/service/language.service';
import { NgxTranslateModule } from 'src/app/translate.module';

@Component({
  selector: 'app-kyc-vehicles-list',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, TooltipModule, NgxTranslateModule],
  templateUrl: './kyc-vehicles-list.component.html',
  styleUrl: './kyc-vehicles-list.component.scss'
})
export class KycVehiclesListComponent {

  @Input() vehicles!: Vehicle[];
  @Input() customerId!: string;
  languages: any[] = languages;
  selectedLanguage!: string;

  constructor(private formatService: FormatCapitalizedConstantsService, private translateService: TranslateService, private router: Router, private languageService: LanguageService) { }


  ngOnInit() {
    this.initializeLocale()
  }
  formatText(value: string): string {
    return this.formatService.formatConstantToNormalText(value);
  }

  viewVehicleDetailClicked(vehicleId: string) {
    this.router.navigate(['/home/customers/' + this.customerId + '/vehicles/' + vehicleId])
  }

  initializeLocale() {
    this.languageService.currentLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.setLanguage(this.selectedLanguage);
    });
  }

  setLanguage(language: string) {
    this.translateService.use(language);
    this.languageService.setLanguage(language);
  }

}
